/**
 * AIChatHeaderActions · 共享对话窗口头部按钮组
 *
 * 用途：「AI 智能分类」菜单页面（AIClassifyPage 的 AISidebar）头部按钮组。
 * 历史上曾被 photoFolders/AIChatDrawer 复用，那个抽屉已下掉，现在仅 AISidebar 用。
 *
 * 内容（从左往右渲染，图标按 Figma 12:2915）：
 *   · 「历史会话」按钮 · HistoryIcon（带回退箭头的时钟）
 *      点击弹出 AIChat 顶部 slide-down 历史会话面板（toggle）
 *   · 「新对话」按钮 · NewConversationIcon（加号）
 *      点击调 startNewConversation 重置会话 + 清 last conv id localStorage
 *
 * 不接 redux 全局；状态/动作通过 props/Context 注入：
 *   · startNewConversation 走 useChatActions()（避免重复 mount session hook）
 *
 * 注: 「分类任务」按钮 (ArchiveTasksButton) 已随文件夹创建任务列表业务一起下线,
 * showTasks prop 暂保留为 no-op (向后兼容外部传值), 可在下次清理移除。
 */

import React from 'react'
import { Tooltip } from 'antd'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import {
  selectHistoryOverlayOpen,
  setHistoryOverlayOpen
} from '../../../../slices/aiClassify'
import { useChatActions } from '../AIChat/ChatActionsContext'
import { trackAIChatClick } from '../../utils/trackClassify'
import { HistoryIcon, NewConversationIcon } from '../SidebarHeaderIcons'
import styles from './AIChatHeaderActions.module.scss'

export interface AIChatHeaderActionsProps {
  /**
   * @deprecated 「分类任务」按钮已下线 · 该 prop 暂保留兼容旧调用方传值, 实际无效
   */
  showTasks?: boolean
}

const AIChatHeaderActions: React.FC<AIChatHeaderActionsProps> = (_props) => {
  const dispatch = useAppDispatch()
  const historyOpen = useAppSelector(selectHistoryOverlayOpen)
  const { startNewConversation } = useChatActions()

  return (
    <span className={styles.actions}>
      {/* 历史会话 · 触发 AIChat 顶部 slide-down 面板 + 蒙层（toggle）
          · 关闭路径：再次点本按钮 / 点蒙层 / 点列表项后自动关 */}
      <Tooltip
        title={historyOpen ? '关闭历史会话' : '查看历史会话'}
        placement="bottom"
      >
        <span
          className={styles.iconWrap}
          onClick={() => {
            if (!historyOpen) trackAIChatClick('history')
            else trackAIChatClick('closeHistory')
            dispatch(setHistoryOverlayOpen(!historyOpen))
          }}
        >
          <HistoryIcon />
        </span>
      </Tooltip>
      {/* 新对话 */}
      <Tooltip title="开始新对话(保留历史会话)" placement="bottom">
        <span
          className={styles.iconWrap}
          onClick={() => {
            trackAIChatClick('startNewConversation')
            startNewConversation()
          }}
        >
          <NewConversationIcon />
        </span>
      </Tooltip>
    </span>
  )
}

export default AIChatHeaderActions
